<div class="ai-assistant-container">
  <div class="ai-assistant-content">
    <div class="info-container">
      <div class="avatar-container">
        @if (aiAssistant()?.assistant?.avatarUrl) {
          <glxy-avatar [src]="aiAssistant()?.assistant?.avatarUrl"></glxy-avatar>
        } @else {
          <glxy-avatar [svgIcon]="aiAssistant()?.decoration?.defaultAvatarIcon"></glxy-avatar>
        }
        <div class="text-container">
          <p class="title">{{ aiAssistant()?.assistant?.name }}</p>
          @if (aiAssistant()?.subtitleKey) {
            <p class="subtitle">{{ aiAssistant()?.subtitleKey ?? '' | translate }}</p>
          }
        </div>
      </div>
      <a mat-stroked-button class="configure-button" [routerLink]="[aiAssistantConfigUrl()]">
        {{ 'INBOX.WEBCHAT.SETTINGS.WEBCHAT_ASSISTANT.CONFIGURE' | translate }}
      </a>
    </div>
  </div>
</div>
